function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }


    var ia = new Uint8Array(bstr.length);
    for (var i = 0; i < bstr.length; i++) {
        ia[i] = bstr.charCodeAt(i);
    }

    return new Blob([ia], { type: mime });
}



function blobToFile(blob, fileName) {
    var myBlob = blob
    myBlob.lastModifiedDate = new Date();
    myBlob.name = fileName;
    return new File(myBlob);
}





function getBoundingClientRect(element) {
    if (element) {
        var rect = element.getBoundingClientRect();
        let object = {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.width,
            height: rect.height,
            x: rect.x,
            y: rect.y
        };

        // if (cb) {
        //     cb(object)
        // }
        return object
    } else {
        return {}
    }
}
const calcResizableElementNewRect = (lang, directon, rect, prevClient, ev) => {
    let width = rect.width;
    let height = rect.height;
    let position = { x: 0, y: 0 }
    // console.log('in english')
    // rtl section needs to be added too**
    if (directon == 'sw') {
        width = rect.width +
            (prevClient.prevClientX -
                ev.clientX)
        height = rect.height -
            (prevClient.prevClientY -
                ev.clientY)
        position = {
            x: ev.clientX - prevClient.prevClientX,
            y: 0
        }
    }
    if (directon == 'se') {
        width = rect.width -
            (prevClient.prevClientX -
                ev.clientX)
        height = rect.height -
            (prevClient.prevClientY -
                ev.clientY)
    }
    if (directon == 'ne') {
        width = rect.width -
            (prevClient.prevClientX -
                ev.clientX)
        height = rect.height +
            (prevClient.prevClientY -
                ev.clientY)
        position = {
            x: 0,
            y: ev.clientY - prevClient.prevClientY
        }
    }
    if (directon == 'nw') {
        width = rect.width +
            (prevClient.prevClientX -
                ev.clientX)
        height = rect.height +
            (prevClient.prevClientY -
                ev.clientY)
        position = {
            x: ev.clientX - prevClient.prevClientX,
            y: ev.clientY - prevClient.prevClientY
        }
    }
    if (directon == 'top') {

        height = rect.height +
            (prevClient.prevClientY -
                ev.clientY)
        position = {
            x: 0,
            y: ev.clientY - prevClient.prevClientY
        }
    }
    if (directon == 'bottom') {

        height = rect.height -
            (prevClient.prevClientY -
                ev.clientY)

    }
    if (directon == 'left') {
        width = rect.width +
            (prevClient.prevClientX -
                ev.clientX)
        position = {
            x:
                ev.clientX - prevClient.prevClientX,
            y: 0
        }

    }
    if (directon == 'right') {
        width = rect.width -
            (prevClient.prevClientX -
                ev.clientX)


    }

    // console.log('position in func', position)
    return { width, height, position }
}


export { dataURLtoFile,blobToFile, getBoundingClientRect, calcResizableElementNewRect }